module.exports = "https://static.wanderu.com/ui-react/_next/static/media/hero-header.77546691.jpg";